import { ReactNode, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconExpandLess from '@mui/icons-material/ExpandLess';
import IconExpandMore from '@mui/icons-material/ExpandMore';
import InfoButton from '../../componentsv2/InfoButton';
import Typography from '../../componentsv2/Typography';
import CopyToClipboardButton from '../CopyToClipboardButton';
import { logEvent } from '@amplitude/analytics-browser';

export default function DetailField({
  title,
  tooltip,
  value,
  isExpandable,
  children,
  size = 6,
  copyable = false,
  isLongValue = false,
  formatValue = (value) => value,
  trackingEvent,
}: {
  title: string;
  tooltip?: string;
  value: string;
  isExpandable?: boolean;
  children?: ReactNode;
  size?: number;
  copyable?: boolean;
  isLongValue?: boolean;
  formatValue?: (value: string) => string;
  trackingEvent?: string;
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Grid container sx={{ alignItems: 'center' }} rowSpacing={1}>
      <Grid item xs={isLongValue ? 3 : size} sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography textAlign="start" fontWeight={700} sx={{ color: isExpanded ? '#283952' : '#4F5A84' }}>
          {title}
        </Typography>
        {!!tooltip && <InfoButton title={tooltip} color="secondary" />}
        {isExpandable && (
          <IconButton
            onClick={() => setIsExpanded((prevExpanded) => !prevExpanded)}
            sx={{ color: isExpanded ? '#283952' : '#4F5A84', p: 0 }}
          >
            {isExpanded ? <IconExpandLess /> : <IconExpandMore />}
          </IconButton>
        )}
      </Grid>
      <Grid
        item
        xs={isLongValue ? 9 : size}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
      >
        <Typography textAlign="end" sx={{ color: isExpanded ? '#283952' : '#4F5A84', fontWeight: 600 }}>
          {formatValue(value)}
        </Typography>
        {copyable && value && (
          <Box sx={{ width: '40px' }}>
            <CopyToClipboardButton
              textToCopy={value}
              customSX={{ paddingY: 0 }}
              onClick={() => {
                if (trackingEvent) {
                  logEvent(trackingEvent, { title, value });
                }
              }}
            />
          </Box>
        )}
      </Grid>
      {isExpandable && isExpanded && children && (
        <Grid item xs={12}>
          <Divider sx={{ borderColor: '#E4EEFC' }} />
        </Grid>
      )}
      {isExpandable && isExpanded && children && (
        <Grid item xs={12}>
          <Grid container sx={{ paddingLeft: '1rem' }} rowSpacing={1}>
            {children}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
